import styles from "./styles.scss";
import { forwardRef } from "react";
import clsx from "clsx";
import { Button } from "@/components/button";
import { IconButtonProps } from "./types";

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      icon: Icon,
      className,
      iconClassName,
      type = "button",
      size,
      disabled,
      ...props
    },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        {...props}
        type={type}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        className={clsx(styles.iconButton, className, size && styles[size])}
        disabled={disabled}
      >
        <Icon className={clsx(styles.icon, iconClassName)} />
      </Button>
    );
  },
);
